class ReadMore extends HTMLElement {
  connectedCallback() {
    this.readMoreButton = this.parentElement.querySelector('.read-more-button');
    this.readMoreButton && this.readMoreButton.addEventListener('click', this.handleReadMoreClick.bind(this));
    
    this.readLessButton = this.parentElement.querySelector('.read-less-button');
    this.readLessButton && this.readLessButton.addEventListener('click', this.handleReadLessClick.bind(this));
    
    this.distanceFromTop = 0;
    const offsetHeight = this.readMoreButton?.offsetHeight || 0;
    const marginTop = parseFloat(window.getComputedStyle(this.readMoreButton).marginTop) || 0;
    this.heightOfReadMoreButton = offsetHeight + marginTop;
    this.style.visibility = 'visible';
    this.handleHeightBasedOnFirstParagraph();
    this.resizeObserver = new ResizeObserver(() => {
      this.handleHeightBasedOnFirstParagraph();
    });
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }

  handleReadMoreClick() {
    if (!this.readMoreButton) return;
    this.resizeObserver.disconnect(); // Disconnect the observer to prevent updating the height when the read more button is clicked
    
    this.style.maxHeight = 'none';
    this.parentElement.style.height = 'auto';
    this.readMoreButton.classList.add('hidden');
    this.readLessButton.classList.remove('hidden');
  }

  handleReadLessClick() {
    if (!this.readLessButton) return;
    this.resizeObserver.observe(this);
    this.readLessButton.classList.add('hidden');
    this.readMoreButton.classList.remove('hidden');
  }

  handleHeightBasedOnFirstParagraph() {
    const firstParagraph = this.querySelector('p');
    if (!firstParagraph) {
      console.warn('Variable paragraph not found');
      return;
    }
    const paragraphRect = firstParagraph.getBoundingClientRect();
    const parentRect = this.getBoundingClientRect();
    // The distance from the top of the parent element to bottom of the first paragraph
    this.distanceFromTop = paragraphRect.top - parentRect.top + paragraphRect.height;

    this.style.maxHeight = `${this.distanceFromTop}px`;
    this.parentElement.style.height = `${this.distanceFromTop + this.heightOfReadMoreButton}px`;
  }
}

if (!window.customElements.get('read-more')) {
  window.customElements.define('read-more', ReadMore);
}

